module.exports = __webpack_public_path__ + "media/images/landing__bg--phone-e892e88c136da9a7601a126171527427.jpg";